import React, { useState, useEffect } from "react";

const GetinTouch: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 620);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 620);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
  };

  return (
    <section
      id="get-in-touch"
      style={{
        paddingTop: isMobile ? "96px" : "140px",
        paddingBottom: "100px",
        paddingLeft: isMobile ? "16px" : "40px",
        paddingRight: isMobile ? "16px" : "40px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "flex-start",
            gap: isMobile ? "24px" : "96px",
          }}
        >
          {/* Form Card */}
          <div
            style={{
              width: isMobile ? "100%" : "50%", // 1/2 of container
              backgroundColor: "#ffffff",
              borderRadius: "24px",
              border: "1px solid #DDDDE3",
              padding: isMobile ? "16px" : "24px",
              boxShadow: "0px 10px 15px 1px rgba(16, 24, 40, 0.05)",
              order: isMobile ? 2 : 1,
            }}
          >
            {/* Form Header */}
            <h3
              style={{
                fontSize: isMobile ? "20px" : "24px",
                fontWeight: "bold",
                color: "#1a365d",
                lineHeight: "1.3",
                marginBottom: "24px",
                margin: "0 0 24px 0",
                textAlign: "left",
              }}
            >
              Get in Touch
            </h3>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              {/* Full Name Field */}
              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1a365d",
                    marginBottom: "8px",
                    textAlign: "left",
                  }}
                >
                  Full Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  placeholder="Enter you first & last name"
                  style={{
                    width: "100%",
                    height: "48px",
                    padding: "12px 16px",
                    border: "1px solid #DDDDE3",
                    borderRadius: "12px",
                    fontSize: "16px",
                    color: "rgba(0, 35, 58, 0.48)",

                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
              </div>

              {/* Email Field */}
              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1a365d",
                    marginBottom: "8px",
                    textAlign: "left",
                  }}
                >
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="example@email.com"
                  style={{
                    width: "100%",
                    height: "48px",
                    padding: "12px 16px",
                    border: "1px solid #DDDDE3",
                    borderRadius: "12px",
                    fontSize: "16px",
                    color: "rgba(0, 35, 58, 0.48)",

                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
              </div>

              {/* Message Field */}
              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1a365d",
                    marginBottom: "8px",
                    textAlign: "left",
                  }}
                >
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="What would you like to ask or tell us?"
                  rows={4}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "1px solid #DDDDE3",
                    borderRadius: "12px",
                    fontSize: "16px",
                    color: "rgba(0, 35, 58, 0.48)",

                    outline: "none",
                    resize: "vertical",
                    minHeight: "96px",
                    boxSizing: "border-box",
                  }}
                />
              </div>

              {/* Submit Button */}
              <div
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "flex-start",
                }}
              >
                <button
                  type="submit"
                  style={{
                    width: isMobile ? "100%" : "25%", // 1/4 width on desktop, full on mobile
                    height: "48px",
                    backgroundColor: "#04EEAD",
                    border: "none",
                    borderRadius: "24px", // Fully rounded
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#1F2937",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>

          {/* Text Content */}
          <div
            style={{
              flex: "1",
              order: isMobile ? 1 : 2,
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <h2
              style={{
                fontSize: isMobile ? "20px" : "28px",
                fontWeight: "bold",
                color: "#1a365d",
                lineHeight: "1.3",
                marginBottom: "24px",
                margin: "0 0 24px 0",
              }}
            >
              Have A Question Or Ready To Start Shipping?
            </h2>

            <p
              style={{
                fontSize: isMobile ? "14px" : "16px",
                color: "#4a5568",
                opacity: "0.76",
                lineHeight: "1.6",
                margin: "0",
              }}
            >
              We're here to help you move goods smarter, faster, and more
              reliably. Whether you're a business owner, farmer, or exporter,
              our team is ready to support your logistics needs across any
              border
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetinTouch;
